import { clamp } from '@immutabl3/utils';
import { type User } from '@/db/types';
import { Badge } from '../components/home/badge';
import { useLeaderboardGlobal } from '../query';
import styles from './personal-profile.module.css';

const calculateCatchRate = (user: User) => {
  const total = user.successes + user.failures;
  const catchRate = total > 0
    ? user.successes / total
    : 0;

  return clamp(Math.round(catchRate * 100), 0, 100);
};

export const PersonalProfile = ({
  user,
}: {
  user: User,
}) => {
  const { data: users } = useLeaderboardGlobal();
  const idx = users.findIndex(u => u.name === user.name) ?? -1;

  return (
    <article className={ styles.profile }>
      <div data-area="badge">
        <Badge name={ user.name } />
      </div>
      <div data-area="main" className={ styles.content }>
        <h1>
          { user.name }
        </h1>
        <span className={ styles.score }>
          { user.score }
        </span>

        <dl>
          <dt>
            session score
          </dt>
          <dd>
            { user.sessionScore }
          </dd>
          <dt>
            session ranking
          </dt>
          <dd>
            { idx + 1 } <small>/ { users.length }</small>
          </dd>
          <dt>
            catch rate
          </dt>
          <dd>
            { calculateCatchRate(user) }%
          </dd>
        </dl>
      </div>
      { idx !== -1 && idx < 3 && (
        <div data-area="medal">
          <div
            className={ styles.medal }
            data-rank={ idx + 1 }
          />
        </div>
      ) }
    </article>
  );
};